import React from 'react'
import { connect } from 'react-redux'
import { Redirect, Route, Switch } from 'react-router-dom'
import { ConnectedRouter, push } from 'react-router-redux'
import { PulseLoader } from 'react-spinners'
import { ToastContainer } from 'react-toastify'

import { logout } from '../actions/auth'

import Logo from '../components/Logo'
import Navbar from '../components/Navbar'
import SideNavbar from '../components/SideNavbar'

import ChecklistAddPage from './ChecklistAddPage'
import ChecklistDailyPage from './ChecklistDailyPage'
import ChecklistEditPage from './ChecklistEditPage'
import ChecklistPage from './ChecklistPage'
import ChecklistResultsPage from './ChecklistResultsPage'
import DashboardPage from './DashboardPage'
import DefectAddPage from './DefectAddPage'
import DefectEditPage from './DefectEditPage'
import DefectPage from './DefectPage'
import LoginPage from './LoginPage'
import ProjectAddPage from './ProjectAddPage'
import ProjectDetailsPage from './ProjectDetailsPage'
import ProjectEditPage from './ProjectEditPage'
import ProjectPage from './ProjectPage'
import RolePage from './RolePage'

import { history } from '../store/configureStore'
import MainAreaPage from "./MainAreaPage";
import MainAreaAddPage from "./MainAreaAddPage";
import MainAreaEditPage from "./MainAreaEditPage";
import DefectAreaPage from "./DefectAreaPage";
import DefectAreaAddPage from "./DefectAreaAddPage";
import DefectAreaEditPage from "./DefectAreaEditPage";

const PrivateRouteContainer = ({ isAuthenticated, component: Component, ...props }) => (
  <Route {...props} render={props => (
    isAuthenticated ? <Component {...props} /> : <Redirect
      to={{ pathname: '/login', state: { from: props.location } }}/>
  )}/>)

const PrivateRoute = connect(({ auth }) => ({
  isAuthenticated: auth.isAuthenticated,
  name: auth.name
}))(PrivateRouteContainer)

const Root = (props) => ( 
  <ConnectedRouter history={history}>
    <div className={`${props.isLoading ? 'loading-overlay' : ''}`}>
      <div className={`${props.isAuthenticated ? '' : 'login-page bg-br-primary'}`}>
        <ToastContainer hideProgressBar={true} newestOnTop={true} autoClose={3000}/>
        <Logo {...props}/>
        <SideNavbar {...props}/>
        <Navbar {...props}/>
        <Route exact path="/login" component={LoginPage}/>
        <div className="br-mainpanel">
          <div className="pd-t-10">
            <div className="loading-container"><PulseLoader color="#00b297" loading={props.isLoading} size={15}/></div>
            <Switch>
              <PrivateRoute exact path="/" component={DashboardPage}/>
              <PrivateRoute exact path="/role" component={RolePage}/>
              <PrivateRoute exact path="/project" component={ProjectPage}/>
              <PrivateRoute exact path="/project/add" component={ProjectAddPage}/>
              <PrivateRoute exact path="/project/:id/details" component={ProjectDetailsPage}/>
              <PrivateRoute exact path="/project/:id/edit" component={ProjectEditPage}/>
              <PrivateRoute exact path="/defect" component={DefectPage}/>
              <PrivateRoute exact path="/defect/add" component={DefectAddPage}/>
              <PrivateRoute exact path="/defect/:id/edit" component={DefectEditPage}/>
              <PrivateRoute exact path="/checklist" component={ChecklistPage}/>
              <PrivateRoute exact path="/checklist/add" component={ChecklistAddPage}/>
              <PrivateRoute exact path="/checklist/:id/edit" component={ChecklistEditPage}/>
              <PrivateRoute exact path="/checklist/daily/:id" component={ChecklistDailyPage}/>
              <PrivateRoute exact path="/checklist/results" component={ChecklistResultsPage}/>
							<PrivateRoute exact path="/mainArea" component={MainAreaPage}/>
							<PrivateRoute exact path="/mainArea/add" component={MainAreaAddPage} />
							<PrivateRoute exact path="/mainArea/:id/edit" component={MainAreaEditPage} />
							<PrivateRoute exact path="/defectArea" component={DefectAreaPage}/>
							<PrivateRoute exact path="/defectArea/add" component={DefectAreaAddPage} />
							<PrivateRoute exact path="/defectArea/:id/edit" component={DefectAreaEditPage} />
            </Switch>
          </div>
        </div>
      </div>
    </div>
  </ConnectedRouter>
)

const mapStateToProps = state => {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    isLoading: state.loading.isLoading,
    name: state.auth.name,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  async onLogoutClick () {
    await dispatch(logout())
    dispatch(push('/login'))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(Root)


// WEBPACK FOOTER //
// ./src/containers/Root.prod.js